'use client'

import { useFilter } from '@rewardops/ui'

import { SEARCH_QUERY_MIN_LENGTH } from '~/utils/sort-utils'
import { replacePlaceholders } from '~/utils/translation-utils'
import { useFilteredItems } from '~/components/hooks/use-filtered-items'
import { PaginationInput } from '~/components/input/pagination-input'
import ItemPagination from '~/components/items-list/items-paginated'
import { useTranslation } from '~/app/i18n/client'
import { SideFilters } from '../../../side-filters'
import { TopFilters } from '../../../top-filters'
import { ProductsSearchProps } from './products-search'

const DesktopProductsSearch = ({
  isFiltersLoading,
  brandsFilterOptions,
  categoriesFilterOptions,
  setItemSearchState,
}: ProductsSearchProps) => {
  const { t } = useTranslation()
  const { searchQuery } = useFilter()

  const {
    loading: isItemsLoading,
    error,
    items,
    totalItems,
    itemsPerPage,
  } = useFilteredItems({ setItemSearchState })

  return (
    <div className="flex">
      <div className="min-w-[16rem] flex-none">
        <SideFilters
          brandsOptions={brandsFilterOptions}
          categoriesOptions={categoriesFilterOptions}
          isLoading={isFiltersLoading || isItemsLoading}
          isPontsRangeEnabled={!!totalItems}
        />
      </div>

      <div className="flex-1 px-4 py-4">
        {!isItemsLoading ? (
          <TopFilters
            headerComponent={
              <div className="flex items-center gap-2">
                <div className="text-3xl font-semibold">
                  {replacePlaceholders(t('search.resultHeader'), {
                    itemsCount:
                      searchQuery?.length < SEARCH_QUERY_MIN_LENGTH
                        ? 0
                        : totalItems ?? 0,
                    searchQuery,
                  })}
                </div>
              </div>
            }
            brandsOptions={brandsFilterOptions}
            categoriesOptions={categoriesFilterOptions}
          />
        ) : null}

        <div className="flex-1 py-2">
          {searchQuery?.length >= SEARCH_QUERY_MIN_LENGTH ? (
            <>
              <ItemPagination
                items={items}
                itemsPerPage={itemsPerPage}
                error={error}
                loading={isItemsLoading}
              />

              <PaginationInput
                className="py-5"
                totalNumberOfItems={totalItems}
              />
            </>
          ) : (
            <div className="px-2 lg:px-0">{t('general.noItems')}</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default DesktopProductsSearch
